export const type = 'form.richTextEditor';
